import { Outlet } from 'react-router-dom'

const InitialQuestionnaireLayout = () => {
  return <Outlet />;
}

export default InitialQuestionnaireLayout